import { render, staticRenderFns } from "./TheParentFleetSelector.vue?vue&type=template&id=387b6570&scoped=true"
import script from "./TheParentFleetSelector.vue?vue&type=script&lang=ts"
export * from "./TheParentFleetSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387b6570",
  null
  
)

export default component.exports